import type { ReactNode } from 'react';
import type { Settings } from 'react-slick';

export interface CardItemSliderData {
  items: ReactNode[];
  overrideSettings?: Settings;
  whiteArrows?: boolean;
}

export interface CardItemSliderProps extends CardItemSliderData {}
